// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"312":"b6637741","420":"a879ba82","480":"3ddeccd5","665":"eecdf4e7","860":"94323706"}[chunkId] + ".css";
};